import type { ReactNode } from 'react';

export const symbol_mode_night: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M376-140q140.07 0 238.53-98Q713-336 713-480t-99.5-242Q514-820 374-820q-20 0-41 2t-32 5q64 72 98 157t34 176q0 91-34 176.5T302-148q11 3 31 5.5t43 2.5Zm5 60q-37.67 0-75.33-7.5Q268-95 233-109q-9-3-14.5-10.81-5.5-7.82-5.5-17.19 0-6.12 2.5-11.56T223-159q68-63 109-145t41-175q0-93-41.5-175T222-800q-5-5-7.5-10.44-2.5-5.44-2.5-11.56 0-9.38 5.5-17.19Q223-847 232-850q36-14 73.5-22t76.5-8q81.28 0 152.76 31.68 71.48 31.69 124.36 86Q712-708 742.5-635.7 773-563.4 773-481.2T742.5-326Q712-253 659-198t-124.72 86.5Q462.55-80 381-80Zm52-399Z"
		/>
	</svg>
);
